var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { openFile, parseBlob } from '../../utils/http-helper';
import { createTimeStamp } from '../../utils/date-utils';
import { ExportOrderDetails } from '../../api/b2b/order-details';
import { pushErrorEvent } from '../../utils/analytics';
export var GetOrderDetailsPDF = function (requestData, orderType, setLoading, setAlertState, page) {
    if (page === void 0) { page = 'detail'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response, blob, fileName, error_1, axiosError;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, ExportOrderDetails(requestData)];
                case 2:
                    response = _a.sent();
                    if (page === 'detail') {
                        return [2 /*return*/, response.data];
                    }
                    blob = parseBlob(response.data, 'data:application/pdf,');
                    fileName = "Order_Details_".concat(createTimeStamp(), ".pdf");
                    openFile(blob, fileName);
                    setAlertState({
                        status: 'success',
                        alertMessage: 'Order Details successfully exported. Check your browser downloads folder for the file.',
                    });
                    return [2 /*return*/, null];
                case 3:
                    error_1 = _a.sent();
                    axiosError = error_1;
                    pushErrorEvent('order details', axiosError.code || '', 'purchase details print', 'inline');
                    setAlertState({
                        status: 'error',
                        alertMessage: 'Something went wrong on our end. Please check back later.',
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/, null];
            }
        });
    });
};
export var GetOrderDetailsCSV = function (requestData, orderType, setLoading, setOpen, setAlertState) {
    setLoading(true);
    ExportOrderDetails(requestData)
        .then(function (response) {
        var _a, _b;
        var blob = parseBlob(response.data, 'data:application/csv,');
        var fileNameCheck = ((_a = requestData.orderDetailsRequest) === null || _a === void 0 ? void 0 : _a.fileName)
            ? (_b = requestData.orderDetailsRequest) === null || _b === void 0 ? void 0 : _b.fileName
            : "Order_Details_".concat(createTimeStamp(), ".csv");
        openFile(blob, fileNameCheck);
        setAlertState({
            status: 'success',
            alertMessage: 'Order Details successfully exported. Check your browser downloads folder for the file.',
        });
    })
        .catch(function (error) {
        pushErrorEvent('order details', error.code || '', 'purchase details export details', 'inline');
        setAlertState({
            status: 'error',
            alertMessage: 'Something went wrong on our end. Please check back later.',
        });
    })
        .finally(function () {
        setLoading(false);
        setOpen(false);
    });
};
